import React from "react";
import "../ImageToPdfPrivacyPolicy/style.css";
import ContactSpin from "../SpinMasterPrivacyPolicy/ContactSpin";

const ImageToPdfTermsConditions = () => {
  return (
    <div className="imageToPdfPrivacyPolicyBody">
      <main className="imageToPdfPrivacyPolicyMain">
        <h1>Terms and Conditions for Image to PDF PDF Reader</h1>
        <p>Last Updated: March 03, 2026</p>
        <p>
          Welcome to Image to PDF PDF Reader (the "Application"). These Terms
          and Conditions ("Terms") govern your use of our Application. By using
          the Application, you agree to these Terms. Please read them carefully.
        </p>

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using the Application, you agree to be bound by these
          Terms. If you do not agree with any part of these Terms, you must not
          use the Application.
        </p>

        <h2>2. Description of Service</h2>
        <p>
          The Application allows users to convert images to PDF format, scan
          documents, as well as compress, merge, and split PDF files.
        </p>
        <ul>
          <li>
            <strong>Local Processing:</strong> All file processing is done
            locally on your device. We do not transmit, upload, store, or access
            your images or PDF files on our servers.
          </li>
          <li>
            <strong>Permissions:</strong> The Application requires Storage,
            Media, and Camera permissions strictly to allow you to import
            images, take photos, and save the generated PDFs back to your
            device.
          </li>
        </ul>

        <h2>3. User Responsibilities</h2>
        <p>As a user of the Application, you agree to:</p>
        <ul>
          <li>
            Use the Application only for lawful purposes and in accordance with
            these Terms.
          </li>
          <li>
            Not use the Application to create, process, or distribute harmful,
            illegal, or malicious content.
          </li>
          <li>
            Not attempt to reverse engineer, decompile, or disassemble the
            Application.
          </li>
          <li>
            Not use the Application in any way that could damage, disable,
            overburden, or impair the Application's functionality.
          </li>
        </ul>

        <h2>4. Intellectual Property</h2>
        <p>
          The Application and its original content, features, design, and
          functionality are owned by us and are protected by international
          copyright, trademark, and other intellectual property laws. The
          Application is provided strictly for your personal, non-commercial
          use.
        </p>

        <h2>5. Privacy</h2>
        <p>
          Your use of the Application is also governed by our Privacy Policy.
          Please review our Privacy Policy to understand our practices regarding
          data security, local file processing, and automatically collected
          technical information.
        </p>

        <h2>6. Third-Party Services & Advertising</h2>
        <p>
          The Application is supported by advertising and uses third-party
          services to deliver ads and monitor app stability. These services do
          not have access to your private images or PDFs.
        </p>
        <ul>
          <li>
            <strong>Google Analytics:</strong> We use Google Analytics
            (Firebase) to collect crash reports and analyze how users interact
            with our Application to improve stability.
          </li>
          <li>
            <strong>Google AdMob:</strong> We display advertisements through
            Google AdMob. This service may collect device information and
            advertising identifiers (like GAID) to provide relevant
            advertisements.
          </li>
        </ul>

        <h2>7. Limitation of Liability</h2>
        <p>
          In no event shall we be liable for any indirect, incidental, special,
          consequential, or punitive damages, including without limitation, loss
          of profits, data, use, goodwill, or other intangible losses, resulting
          from:
        </p>
        <ul>
          <li>
            Your access to or use of, or inability to access or use, the
            Application.
          </li>
          <li>
            Any accidental loss or corruption of files processed locally on your
            device.
          </li>
        </ul>

        <h2>8. Changes to Terms</h2>
        <p>
          We reserve the right to modify or replace these Terms at any time. We
          will provide notice of any changes by posting the new Terms on this
          page and updating the "Last Updated" date. Your continued use of the
          Application after any such changes constitutes your acceptance of the
          new Terms.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          If you have any questions about these Terms & Conditions, please
          contact us at:
        </p>
        <ContactSpin />
      </main>
    </div>
  );
};

export default ImageToPdfTermsConditions;
